<script setup lang="ts">
/* Thin router host. The review application lives in Reader; `/admin` has its
 * own deliberately isolated view. */
</script>

<template>
  <RouterView />
</template>
